import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import { Loading } from "@/components/common";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Audits from "@/pages/Audits";
import AuditWorkspace from "@/pages/AuditWorkspace";
import Interview from "@/pages/Interview";
import Questionnaires from "@/pages/Questionnaires";
import Admin from "@/pages/Admin";
import Logs from "@/pages/Logs";
import Account from "@/pages/Account";
import Planned from "@/pages/Planned";
import Planning from "@/pages/Planning";
import Reports from "@/pages/Reports";
import ModulePicker from "@/pages/ModulePicker";

function Protected({ children }) {
  const { user, mfaEnforced } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (mfaEnforced && !user.mfa_enabled && loc.pathname !== "/account") return <Navigate to="/account" replace />;
  return children;
}

document.title = "HR360 Motravay";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="audits" element={<Audits />} />
              <Route path="audits/:id" element={<AuditWorkspace />} />
              <Route path="interviews/:id" element={<Interview />} />
              <Route path="questionnaires" element={<Questionnaires />} />
              <Route path="admin" element={<Admin />} />
              <Route path="logs" element={<Logs />} />
              <Route path="account" element={<Account />} />
              <Route path="planned/:module" element={<Planned />} />
              <Route path="planning" element={<Planning />} />
              <Route path="reports" element={<Reports />} />
              <Route path="m/:module" element={<ModulePicker />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
